import {useEffect, useMemo, useRef} from 'react';
import {init as initAutomation} from '../services/automation-engine';

export function useAutomationEngine(triggers, deps) {
    const engineRef = useRef(null);


    const engine = useMemo(() => {
        if (!engineRef.current) {
            engineRef.current = initAutomation(deps);
        }
        return engineRef.current;

    }, []);


    useEffect(() => {
        if (!engineRef.current) return;

        engineRef.current.deps = {...engineRef.current.deps, ...deps};
    }, [deps]);


    useEffect(() => {
        engine?.setTriggers(Array.isArray(triggers) ? triggers : []);
    }, [engine, triggers]);


    useEffect(() => {
        if (!engine) return;
        engine.start();
        return () => {
            engine.stop();
        };
    }, [engine]);


    useEffect(() => {
        if (!engine) return;
        if (typeof window === 'undefined') return;

        const isIframe = typeof window !== 'undefined' && window.parent && window.parent !== window;
        const wantBridge = deps?.hostBridge !== false && isIframe;

        if (!wantBridge) return;

        const allowed = Array.isArray(deps?.hostBridgeAllowedOrigins)
            ? deps.hostBridgeAllowedOrigins
            : [];

        engine.attachHostBridge(allowed);

        return () => {
            engine.detachHostBridge();
        };
    }, [engine, deps?.hostBridge, deps?.hostBridgeAllowedOrigins]);

    return engine;
}
